import { useEffect, useState } from "react"
import isClient from "../utils/browser/isClient"

const sizes = new Map([
  ["mobile", "(max-width: 767px)"],
  ["tablet", "(max-width: 1110px)"],
  ["desktop", "(min-width: 1110px)"],
])

const useMediaQuery = (size) => {
  const updateMatches = () => {
    if (!isClient()) return false
    const query = sizes.get(size) || `(max-width: ${size}px)`
    return window.matchMedia(query).matches
  }

  const [matches, setMatches] = useState(updateMatches)

  useEffect(() => {
    const handleResize = () => setMatches(updateMatches)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return matches
}

export default useMediaQuery
